/**
 * Deployed identifiers. None of these are secrets: both app clients are public
 * (`generateSecret: false`), which is exactly why PKCE is what protects the
 * flow rather than a shared secret (D47).
 *
 * Committed rather than kept in `.env` so a build is reproducible and a wrong
 * value is a diff rather than a mystery.
 */
export const AUTH = {
  region: 'ap-southeast-1',
  userPoolId: 'ap-southeast-1_R1i2zKpRD',
  guestClientId: '6stlimbe964pvj2cfng8l58f9e',
  adminClientId: '48uhi7m8g1u8fr2pi1r5dnhj51',
  /** Managed login. Served by a CloudFront distribution Cognito owns. */
  domain: 'https://auth.megandvideet.com',
  api: 'https://sk63dr3e2h.execute-api.ap-southeast-1.amazonaws.com',
} as const;

/**
 * Cognito's native passwordless EMAIL_OTP sends **eight** digits, not six, and
 * the length is not configurable. The app was built for six — every screen, the
 * input grid and the email copy all said so — which would have rejected every
 * real code while looking entirely correct.
 */
export const CODE_LENGTH = 8;

export const redirectUri = () => `${window.location.origin}/auth/callback`;
export const logoutUri = () => `${window.location.origin}/`;
